import React, { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/services/hooks";
// GET all designs
import { getAll } from "@/services/designServices/designAction";
// Get All products
// Get All categories
// Get All ads
// Get All posts linked to the current blog

// Add new tempalte
import { addTemplate } from "@/services/templateServices/templateAction";
// component that will let us load the content or required vars
import VariablesSelectByTypes from "@/components/dashboard/VariablesSelectByTypes";
// reactstrap components
import {
  Col,
  Label,
  FormGroup,
  InputGroup,
  InputGroupText,
  Input,
  Row,
  Form,
} from "reactstrap";
// nodejs library that concatenates classes
import classnames from "classnames";
// select Input
import Select from "react-select";
import NotificationAlertOptions from "@/layouts/Alerts";
import VariableField from "../../variableFields/VariableField";
import ServiceField from "../../variableFields/ServiceField";
import { useVariableOptions } from "../../variableFields/useVariableOptions";
import { asCaught } from "@/services/caughtError";
// Media selector
// shared semicolon-separated Array parser (SCRUM-550)

// template types for drop down
const types = [
  { label: "Home Page", value: "home_page" },
  { label: "Category page", value: "intro_page" },
  { label: "Listing page", value: "listing_page" },
  { label: "Product details page", value: "product_details" },
  { label: "Contact page with a form", value: "contact_form" },
  { label: "Blog index", value: "blog_index" },
  { label: "blog page details", value: "blog_page" },
  { label: "Author page", value: "author_page" },
  { label: "info page", value: "info_article" },
  { label: "Redirection page", value: "redirect_page" },
  { label: "Error page", value: "error_page" },
  { label: "Sitemap", value: "sitemap_page" },
  { label: "How we score", value: "score_method_page" },
  { label: "Privacy Page", value: "privacy_page" },
  { label: "Navigation Bar", value: "navigation" },
  { label: "Footer", value: "footer" },
    { label: "product simple", value: "product_simple" },


  
];



//Template Object
const templateFormInput = {
  name: "",
  type: "",
  template_src: "",
  design: {
    _id: "",
    name: "",
    source: "",
  },
  content_variables: {
    ContentRequired: [],
    ContentOptional: [],
  },
  settings_variables: {
    SettingsRequired: [],
    SettingsOptional: [],
  },
};

// The create card deviates from the registry for one type (characterized in
// SCRUM-630): service items keep a plain image-URL text input next to the
// picker. (Its `Image: null` pin went with the Image block, SCRUM-2207.)
const ServiceFieldWithUrl = (props: React.ComponentProps<typeof ServiceField>) => <ServiceField {...props} showUrlInput />;
const CREATE_CARD_OVERRIDES = { service: ServiceFieldWithUrl };

export type TemplateFormProps = { switchToDesignListHandler: () => void | Promise<void> };

function TemplateForm(props: TemplateFormProps) {
  const dispatch = useAppDispatch();
  // shared option lists for the entity building blocks (SCRUM-554)
  const variableOptions = useVariableOptions();
  // VariableField blocks report (name, value); write it into the right bucket
  const applyBucketValue = (bucket) => (name, value) => {
    setTemplate((prev) => ({
      ...prev,
      settings_variables: {
        ...prev.settings_variables,
        [bucket]: prev.settings_variables[bucket].map((settingVar) =>
          settingVar.variable === name ? { ...settingVar, value } : settingVar
        ),
      },
    }));
  };
  const designs = useAppSelector((state) => state.designs.designs);
  const [template, setTemplate] = useState<any>(templateFormInput); // any: no client type for the template document yet; fields are edited by name
  const [selectedDesign, setSelectedDesign] = useState<any>(templateFormInput.design); // any: the populated design document used as the Select value; the designs slice types it any[] (designSlice.ts:24)
  const [designsLocal, setDesignsLocal] = useState<any[] | undefined>(undefined); // any: copies the designs slice, typed any[] there (designSlice.ts:24)
  const currentSite = useAppSelector(
    (state) => state.sites.site
  );
  useEffect(() => {
    if (currentSite){
      setTemplate({
        ...template,
        site: currentSite._id,
      });
    }
  }, [currentSite])
  
  useEffect(() => {
    if (!designs.length) {
      dispatch(getAll());
    }
    setDesignsLocal(designs.map((des) => ({ value: des, label: des.name })));
  }, [designs]);











  // Change template name
  const onChangeTemlateName = (e) => {
    setTemplate({
      ...template,
      name: e.target.value,
    });
  };

  // change template src
  const onChangeTemlateSrc = (e) => {
    setTemplate({
      ...template,
      template_src: e.target.value,
    });
  };

  // change template type
  const SelectTemplateTypeInputHandler = (event) => {
    const value = event !== null ? event.value : "";
    setTemplate({ ...template, type: value });
  };

  // change template design
  const SelectDesignInputHandler = (event) => {
    const value = event !== null ? event.value : "";

    setSelectedDesign({ value: value, label: value.name });
    setTemplate({
      ...template,
      design: value,
      // SCRUM-1225: this used to seed the buckets from the DESIGN's
      // settings_variables. Design-level settings are removed, so a new template
      // starts empty and the editor picks what it needs. Leaving the old line in
      // place would set `undefined` here and crash the form on the next render,
      // which is how this dependency was found.
      //
      // Behaviour change, deliberate: measured over the 17 seeded templates, the
      // four the design offered were kept by almost nobody — rightArrow and
      // close_label on 0, newsarchive on 1, blogdir on 2 — while readMore, on 12
      // of 17, was never among them. The seed did not predict what templates
      // actually declare.
      settings_variables: { SettingsRequired: [], SettingsOptional: [] },
    });
  };

  // change template settings / content variables
  // Functional updater (SCRUM-860): reads the latest state so two picker
  // changes landing in the same React batch don't clobber each other.
  const setVariables = (group, requiredKey, optionalKey) => (value, status) => {
    const key = status === "required" ? requiredKey : status === "optional" ? optionalKey : null;
    if (!key) return;
    setTemplate((prev) => ({ ...prev, [group]: { ...prev[group], [key]: value } }));
  };
  const onChangeSettignsVariables = setVariables("settings_variables", "SettingsRequired", "SettingsOptional");
  const onChangeContentVariable = setVariables("content_variables", "ContentRequired", "ContentOptional");



































  // Handle change Optional settings variable values
  const onChangeOptioanlSettingsVarValue = (e, action) => {
    let targetVariable: { variable?: string; value?: unknown } = {};
    // case the setting variable type is a String / Number
    if (e.target) {
      targetVariable = template.settings_variables.SettingsOptional.filter(
        (settingVar) => settingVar.variable === e.target.name
      )[0];
      targetVariable.value = e.target.value;
      setTemplate({
        ...template,
        settings_variables: {
          ...template.settings_variables,
          SettingsOptional: [
            ...template.settings_variables.SettingsOptional.map((settingVar) =>
              settingVar.variable !== e.target.name
                ? settingVar
                : targetVariable
            ),
          ],
        },
      });
    }
    // case the setting variable type is Boolean /Proudct/Ad/ catrgory
    if (e.label) {
      targetVariable = template.settings_variables.SettingsOptional.filter(
        (settingVar) => settingVar.variable === action.name
      )[0];
      targetVariable.value = e.value;

      setTemplate({
        ...template,
        settings_variables: {
          ...template.settings_variables,
          SettingsOptional: [
            ...template.settings_variables.SettingsOptional.map((settingVar) =>
              settingVar.variable !== action.name ? settingVar : targetVariable
            ),
          ],
        },
      });
    }
  };





  // Notification
  const notify = (type: string, template: { name?: string }, message?: string) => {
    NotificationAlertOptions(
      type,
      message || `Template ${template.name} has been added successfully`
    );
  };

  // Submit form
  async function SubmitFormHandler(event) {
    event.preventDefault();
    try {
      await dispatch(addTemplate(template));
    } catch (err) {
      notify(
        "error",
        template,
        `Template ${template.name} could not be saved: ${
          asCaught(err).response?.data?.message || asCaught(err).message
        }`
      );
      return;
    }
    await notify("success", template);
    setSelectedDesign({});
    setTemplate(templateFormInput);
    await props.switchToDesignListHandler();
  }

  if (designs.length > 0) {
    return (
        <Form onSubmit={SubmitFormHandler}>
          <Row>
            <FormGroup className="col-md-6">
              <Row>
                <Label
                  className="form-control-label"
                  htmlFor="example-text-input"
                  md="2"
                >
                  Template Name
                </Label>
                <Col md="10">
                  <InputGroup
                    className={classnames("input-group-merge", {
                      focused: template["name"],
                    })}
                  >
                    
                      <InputGroupText>
                        <i className="ni ni-badge text-primary" />
                      </InputGroupText>
                    <Input
                      placeholder="Insert Template Name"
                      type="text"
                      value={template["name"]}
                      onChange={onChangeTemlateName}
                      name="name"
                      required
                    />
                  </InputGroup>

                  {template.name ? (
                    <div className="text-success">Looks good!</div>
                  ) : (
                    <div className="text-danger">
                      {" "}
                      Please insert template name{" "}
                    </div>
                  )}
                </Col>
              </Row>
            </FormGroup>
            <FormGroup className="col-md-6">
              <Row>
                <Label
                  className="form-control-label"
                  htmlFor="example-text-input"
                  md="2"
                >
                  Select Template Type
                </Label>
                <Col md="10">
                  <Select classNamePrefix="select"
                    value={types.filter(
                      (option) => option.value === template["type"]
                    )}
                    name="type"
                    options={types}
                    onChange={SelectTemplateTypeInputHandler}
                    isClearable={true}
                    isSearchable={true}
                    required
                  />
                  {template.type ? (
                    <div className="text-success">Looks good!</div>
                  ) : (
                    <div className="text-danger">
                      {" "}
                      Please select template type{" "}
                    </div>
                  )}
                </Col>
              </Row>
            </FormGroup>
            <FormGroup className="col-md-6">
              <Row>
                <Label
                  className="form-control-label"
                  htmlFor="example-text-input"
                  md="2"
                >
                  Select Existing Design
                </Label>
                <Col md="10">
                  <Select classNamePrefix="select"
                    // value={designsLocal.filter(
                    // 	(option) => option['_id'] === template.design['_id']
                    // )}
                    value={selectedDesign}
                    name="design"
                    options={designsLocal}
                    onChange={SelectDesignInputHandler}
                    isClearable={true}
                    isSearchable={true}
                    required
                  />
                  {template.design._id ? (
                    <div className="text-success">Looks good!</div>
                  ) : null}
                </Col>
              </Row>
            </FormGroup>

            <FormGroup className="col-md-6">
              <Row>
                <Label
                  className="form-control-label"
                  htmlFor="example-text-input"
                  md="2"
                >
                  Template Source path
                </Label>
                <Col md="10">
                  <InputGroup
                    className={classnames("input-group-merge", {
                      focused: template["template_src"],
                    })}
                  >
                    
                      <InputGroupText>
                        <i className="ni ni-folder-17 text-primary" />
                      </InputGroupText>
                    <Input
                      placeholder={`Insert Template Path example :  template / ${template["design"].name} / Filename`}
                      type="text"
                      value={template["template_src"]}
                      onChange={onChangeTemlateSrc}
                      name="template_src"
                      required
                    />
                  </InputGroup>
                  {template.template_src ? (
                    <div className="text-success">Looks good!</div>
                  ) : (
                    <div className="text-danger">
                      {" "}
                      Please insert template source path{" "}
                    </div>
                  )}
                </Col>
              </Row>
            </FormGroup>
          </Row>
          {template.design._id ? (
            <>
              {/* START SETTINGS VARIABLES  */}
              <h4 className="mb-0">Design Settings Variables</h4>
              <Row>
                <FormGroup className="col-md-6" style={{ marginTop: "15px" }}>
                  <Col md="10">
                    {/* DISPLAY SUCCESS OR ERROR MSG ( if  REQUIRED Settings VARIABLE.LENGTH > 0) */}
                    <Row>
                      {template.settings_variables.SettingsRequired.length >
                      0 ? (
                        <div className="text-success">Looks good!</div>
                      ) : (
                        <div className="text-danger">
                          {" "}
                          Please insert template Required Settings{" "}
                        </div>
                      )}
                    </Row>
                    {/* END MESSAGE */}

                    {/* REQUIRED SETTINGS VAR SSSELECTOR */}
                    <VariablesSelectByTypes
                      status="required"
                      type="setting"
                      inputLabel="Required"
                      handleVariableChange={onChangeSettignsVariables}
                      dataValue={template.settings_variables.SettingsRequired}
                      show
                    ></VariablesSelectByTypes>
                    {/* END SELECTOR */}

                    {/* ALLOW USER TO SET SELECTED SETINGS VARIABLES VALUES => REQUIRED */}
                    {template.settings_variables.SettingsRequired.map(
                      (settingVar) => (
                        <VariableField
                          key={settingVar.variable}
                          settingVar={settingVar}
                          options={variableOptions[settingVar.type]}
                          onChange={applyBucketValue("SettingsRequired")}
                          overrides={CREATE_CARD_OVERRIDES}
                        />
                      )
                    )}
                    {/* END Required SETTINGS VARIABLES VALUES */}
                  </Col>
                </FormGroup>
                <FormGroup className="col-md-6" style={{ marginTop: "15px" }}>
                  <Col md="10">
                    {/* DISPLAY SUCCESS OR WARINIG MSG ( if  OPTIONAL Settings VARIABLE.LENGTH > 0) */}
                    <Row>
                      {template.settings_variables.SettingsOptional.length >
                      0 ? (
                        <div className="text-success">Looks good!</div>
                      ) : (
                        <div className="text-orange">
                          {" "}
                          No template Optional Settings{" "}
                        </div>
                      )}
                    </Row>
                    {/* END MESSAGE */}

                    {/* OPTIONAL SETTINGS VAR SELECTOR */}
                    <VariablesSelectByTypes
                      status="optional"
                      type="setting"
                      inputLabel="Optional"
                      handleVariableChange={onChangeSettignsVariables}
                      dataValue={template.settings_variables.SettingsOptional}
                      show
                    ></VariablesSelectByTypes>
                    {/* END SELECTOR */}
                    {/* ALLOW USER TO SET SELECTED SETINGS VARIABLES VALUES => OPTIONAL */}
                    {template.settings_variables.SettingsOptional.map(
                      (settingVar) => (
                        <VariableField
                          key={settingVar.variable}
                          settingVar={settingVar}
                          options={variableOptions[settingVar.type]}
                          onChange={applyBucketValue("SettingsOptional")}
                          overrides={CREATE_CARD_OVERRIDES}
                        />
                      )
                    )}
                    {/* END Optional SETTINGS VARIABLES VALUES */}
                  </Col>
                </FormGroup>
              </Row>

              {/* END SETTINGS VARIABLES */}

              {/* START CONETNT VARIABLES */}
              <h4 className=" text-center" style={{ margin: "15px" }}>
                Insert Content Variables
              </h4>
              <Row>
                <FormGroup className="col-md-6">
                  <Col md="10">
                    {/* DISPLAY SUCCESS OR ERROR MSG ( if  REQUIRED CONTENT VARIABLE.LENGTH > 0) */}
                    <Row>
                      {template.content_variables.ContentRequired.length > 0 ? (
                        <div className="text-success">Looks good!</div>
                      ) : (
                        <div className="text-danger">
                          {" "}
                          Please insert template Required Content{" "}
                        </div>
                      )}
                    </Row>
                    {/* END MESSAGE */}
                    <VariablesSelectByTypes
                      status="required"
                      type="content"
                      inputLabel="Required"
                      handleVariableChange={onChangeContentVariable}
                      dataValue={template.content_variables.ContentRequired}
                      onReorder={onChangeContentVariable}
                      show
                    ></VariablesSelectByTypes>
                  </Col>
                </FormGroup>
                <FormGroup className="col-md-6">
                  <Col md="10">
                    {/* DISPLAY SUCCESS OR WARNING MSG ( if  Optional CONTENT VARIABLE.LENGTH > 0) */}
                    <Row>
                      {template.content_variables.ContentOptional.length > 0 ? (
                        <div className="text-success">Looks good!</div>
                      ) : (
                        <div className="text-orange">
                          {" "}
                          No template Optional Content{" "}
                        </div>
                      )}
                    </Row>
                    {/* END MESSAGE */}
                    <VariablesSelectByTypes
                      status="optional"
                      type="content"
                      inputLabel="Optional"
                      handleVariableChange={onChangeContentVariable}
                      dataValue={template.content_variables.ContentOptional}
                      onReorder={onChangeContentVariable}
                      show
                    ></VariablesSelectByTypes>
                  </Col>
                </FormGroup>
              </Row>

              {/* END CONTENT VARIABLES */}
            </>
          ) : (
            <div className="text-orange">
              {" "}
              Please Select Design Before finishing Form
            </div>
          )}

          <button
            className="btn btn-outline-primary mr-1 float-right"
            type="submit"
          >
            Save Template
          </button>
        </Form>

    );
  } else {
    return <>Designs are loading..</>;
  }
}

export default TemplateForm;
